import { Link } from 'react-router-dom';

export default function WasWirTunPage() {
  return (
    <div className="bg-white" style={{ fontFamily: 'Inter, -apple-system, sans-serif' }}>
      {/* Hero */}
      <section className="py-24 md:py-32 bg-gradient-to-b from-[#FAF9F7] to-white">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <div className="max-w-3xl">
            <span className="text-xs font-semibold text-[#C4A962] uppercase tracking-[2px] mb-4 block">
              Was wir tun
            </span>
            <h1 className="text-4xl md:text-[52px] font-bold text-gray-900 leading-tight tracking-tight mb-6">
              Potenziale erkennen.<br />Möglichkeiten schaffen.
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              asK-mi ist eine Förder- und Entwicklungsorganisation für junge Menschen aus dem neurodiversen Spektrum. 
              Wir sehen nicht zuerst Defizite oder Diagnosen – wir sehen Menschen mit individuellen Fähigkeiten, 
              besonderen Wahrnehmungen und Entwicklungspotenzial.
            </p>
          </div>
        </div>
      </section>

      {/* Grundidee */}
      <section className="py-24 md:py-32">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <span className="text-xs font-semibold text-[#C4A962] uppercase tracking-[2px] mb-4 block">
                Unsere Grundidee
              </span>
              <h2 className="text-3xl md:text-[38px] font-bold text-gray-900 tracking-tight mb-6">
                Wir sehen den Menschen – nicht die Diagnose.
              </h2>
              <div className="text-[17px] text-gray-600 leading-relaxed space-y-4">
                <p>
                  Viele junge Menschen aus dem neurodiversen Spektrum werden vor allem über ihre Schwierigkeiten wahrgenommen.
                </p>
                <p>
                  <strong className="text-gray-900">asK-mi möchte den Blick verändern.</strong>
                </p>
                <p>
                  Wir sehen Menschen mit individuellen Fähigkeiten, besonderen Wahrnehmungen, ungewöhnlichen Denkweisen, 
                  Kreativität und Entwicklungspotenzial.
                </p>
                <p>
                  asK-mi möchte dazu beitragen, dass diese Potenziale erkannt, entwickelt und in konkrete Möglichkeiten 
                  übersetzt werden.
                </p>
              </div>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-lg">
              <img 
                src="https://static.prod-images.emergentagent.com/jobs/d4ed44b3-63d8-417d-957c-4836bdf688a4/images/8e88facd68bd457e511ae18326ba12c8dcc9a338b5b466ff273bcc92deacf675.jpeg" 
                alt="Menschen in Begegnung und Austausch"
                className="w-full h-[450px] object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Wie wir arbeiten */}
      <section className="py-24 md:py-32 bg-[#FAF9F7]">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <div className="text-center mb-16">
            <span className="text-xs font-semibold text-[#C4A962] uppercase tracking-[2px] mb-4 block">
              Wie wir arbeiten
            </span>
            <h2 className="text-3xl md:text-[42px] font-bold text-gray-900 tracking-tight mb-6">
              Verbinden. Ermöglichen. Wirken.
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              asK-mi unterstützt nicht zwangsläufig selbst direkt. Wir bringen Förderer, Menschen, Einrichtungen, 
              Unternehmen und Projekte zusammen und ermöglichen gezielte Förderung.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-[#E8E4DE]">
            <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
              <div className="text-center">
                <div className="w-20 h-20 rounded-full bg-[#F5F3F0] border-2 border-[#E8E4DE] flex items-center justify-center mx-auto mb-3 text-2xl">
                  🤝
                </div>
                <p className="font-semibold text-gray-900 text-sm">Förderer</p>
              </div>
              <div className="text-xl text-[#C4A962]">→</div>
              <div className="text-center">
                <div className="w-20 h-20 rounded-full bg-[#C4A962] flex items-center justify-center mx-auto mb-3">
                  <img src="/images/brand/ask-mi-logo-clean.webp" alt="asK-mi" className="h-10 w-auto" />
                </div>
                <p className="font-semibold text-gray-900 text-sm">asK-mi</p>
              </div>
              <div className="text-xl text-[#C4A962]">→</div>
              <div className="text-center">
                <div className="w-20 h-20 rounded-full bg-[#F5F3F0] border-2 border-[#E8E4DE] flex items-center justify-center mx-auto mb-3 text-2xl">
                  🔍
                </div>
                <p className="font-semibold text-gray-900 text-sm">Prüfung</p>
              </div>
              <div className="text-xl text-[#C4A962]">→</div>
              <div className="text-center">
                <div className="w-20 h-20 rounded-full bg-[#F5F3F0] border-2 border-[#E8E4DE] flex items-center justify-center mx-auto mb-3 text-2xl">
                  💡
                </div>
                <p className="font-semibold text-gray-900 text-sm">Förderung</p>
              </div>
              <div className="text-xl text-[#C4A962]">→</div>
              <div className="text-center">
                <div className="w-20 h-20 rounded-full bg-[#F5F3F0] border-2 border-[#E8E4DE] flex items-center justify-center mx-auto mb-3 text-2xl">
                  👨‍👩‍👧
                </div>
                <p className="font-semibold text-gray-900 text-sm">Jugendliche & Familien</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Unsere Haltung */}
      <section className="py-24 md:py-32">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <div className="text-center mb-16">
            <span className="text-xs font-semibold text-[#C4A962] uppercase tracking-[2px] mb-4 block">
              Unsere Haltung
            </span>
            <h2 className="text-3xl md:text-[42px] font-bold text-gray-900 tracking-tight">
              Was Förderung für uns bedeutet.
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { title: 'Möglichkeiten schaffen', text: 'Nicht nur finanzielle Unterstützung, sondern echte Chancen eröffnen.' },
              { title: 'Beziehungen ermöglichen', text: 'Menschen zusammenbringen, die einander weiterbringen.' },
              { title: 'Zugänge öffnen', text: 'Türen öffnen, die sonst verschlossen bleiben würden.' },
              { title: 'Potenziale entwickeln', text: 'Fähigkeiten erkennen und gezielt fördern.' },
              { title: 'Teilhabe ermöglichen', text: 'Menschen aktiv in die Gesellschaft einbinden.' },
              { title: 'Zukunft gestalten', text: 'Langfristige Perspektiven schaffen, nicht nur kurzfristige Hilfe.' },
            ].map((item, i) => (
              <div 
                key={i}
                className="bg-[#F5F3F0] rounded-xl p-8 hover:bg-white hover:shadow-md hover:border-[#C4A962] border border-transparent transition-all duration-300"
              >
                <h3 className="font-semibold text-gray-900 text-lg mb-3">{item.title}</h3>
                <p className="text-gray-600 leading-relaxed">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 md:py-32 bg-gray-900 text-white text-center">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <h2 className="text-3xl md:text-[42px] font-bold tracking-tight mb-6">
            Erfahren Sie mehr über unsere Förderbereiche.
          </h2>
          <p className="text-lg text-white/70 max-w-xl mx-auto mb-10">
            Entdecken Sie, wie asK-mi Menschen, Einrichtungen, Unternehmen und Projekte fördert.
          </p>
          <Link 
            to="/foerdern"
            className="inline-flex items-center gap-2 bg-[#C4A962] hover:bg-[#D4B972] text-gray-900 px-9 py-4 rounded-md font-semibold text-lg transition-all hover:-translate-y-0.5"
          >
            Fördern entdecken
          </Link>
        </div>
      </section>
    </div>
  );
}
